export default "__VITE_ASSET__7a889967__"